import React from 'react';
import './VideoChat.scss';
import Toast from '../../components/Toast';

import AgoraVideoCall from './AgoraVideoCall';
import { PATHS, AGORA_VIDEO_CALL_APP_ID } from '../../common/constants';

const AGORA_APP_ID = AGORA_VIDEO_CALL_APP_ID; // set your app id here

export default class VideoChat extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sentByName:
        this.props.location && this.props.location.state
          ? this.props.location.state.sentByName
          : '',
      sentToName:
        this.props.location && this.props.location.state
          ? this.props.location.state.sentToName
          : '',
      serviceRequestId:
        this.props.location && this.props.location.state
          ? this.props.location.state.serviceRequestId
          : '',
      connected: false,
      onExitClicked: false,
      enableExit: false,
      navigateToHome: false,
    };
    this.videoProfile = '480p_4';
    this.channel =
      this.props.location && this.props.location.state
        ? this.props.location.state.chatId
        : '';
    this.transcode = 'interop';
    this.attendeeMode = 'video';
    this.baseMode = 'avc';

    this.appId = AGORA_APP_ID;
    if (!this.appId) {
      return alert('Get App ID first!');
    }
    this.uid = undefined;
  }

  componentWillMount() {
    let string = window.location.href;
    let splitValue = string.split('chatId=')[1];
    if (splitValue !== undefined) {
      this.channel = splitValue.split('/')[0];
      let name = splitValue.split('/')[1];
      this.setState({ sentByName: name, navigateToHome: true });
    }
  }

  isUserConnected = () => {
    this.setState({ connected: true });
  };

  navigateToBack = () => {
    if (this.state.navigateToHome) {
      this.props.history.push(PATHS.PROPERTIES_LIST);
    } else {
      let location = this.props.location;
      this.props.history.push({
        pathname: location.state.url,
        state: {
          activeTab: location.state?.activeTab ? location.state.activeTab : 2,
        },
      });
    }
    this.setState({
      onExitClicked: true,
    });
  };

  render() {
    return (
      <div className="metting ">
        <div class="form__header">
          {this.state.enableExit === true ? (
            <>
              <div class="form__dismiss">
                <i
                  class="icon fa-arrow-left fal"
                  onClick={() => this.navigateToBack()}
                />
              </div>
              <div class="form__actions">
                <div class="form__dismiss">
                  <i
                    class="icon fa-times fal"
                    onClick={() => this.navigateToBack()}
                  />
                </div>
              </div>
            </>
          ) : null}
        </div>
        <div className="wrapper meeting">
          <div className="ag-header">
            <div className="ag-header-lead">
              <h2 className="video-text">Video Chat</h2>
            </div>
          </div>
          <div className="ag-main">
            <div className="ag-container">
              {this.state.connected ? null : (
                <span>
                  <div className="ag-message">
                    <Toast
                      color="teal"
                      message={`You have initiated a video chat with ${this.state.sentByName}.We have sent ${this.state.sentByName} an email to let them know so he can join the video chat.Please note, it may take 1-5 minutes before ${this.state.sentByName} joins the chat.`}
                    />
                  </div>
                </span>
              )}
              <div className="ag-container-sub">
                <AgoraVideoCall
                  videoProfile={this.videoProfile}
                  channel={this.channel}
                  transcode={this.transcode}
                  attendeeMode={this.attendeeMode}
                  baseMode={this.baseMode}
                  appId={this.appId}
                  uid={this.uid}
                  isUserConnected={this.isUserConnected}
                  navigateToBack={this.navigateToBack}
                  connected={this.state.connected}
                  sentByName={this.state.sentByName}
                  enableExit={() => this.setState({ enableExit: true })}
                  onExitClicked={this.state.onExitClicked}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
